/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".cursor_p[_ngcontent-%COMP%] {\n  cursor: pointer; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvd3d3L3Zob3N0cy90bXMuZGF5ZGV2YnVpbGQvc3JjL2FwcC9tYWluL2hyL3RyYW5zbGF0b3IvdHJhbnNsYXRvci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGVBQWUsRUFBQSIsImZpbGUiOiJzcmMvYXBwL21haW4vaHIvdHJhbnNsYXRvci90cmFuc2xhdG9yLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmN1cnNvcl9we1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbn0iXX0= */"];
export { styles as styles };
